import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" ? !navigator.onLine : false);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      role="status"
      className="slide-down border-b border-[hsl(var(--brand-ochre)/0.4)] bg-[hsl(var(--brand-ochre)/0.12)] text-[hsl(var(--brand-ochre))]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-2 text-xs font-medium">
        <WifiOff size={14} />
        <span className="text-foreground/90">
          Sin conexión. 
          <span className="text-muted-foreground font-normal">Guardamos todo en el dispositivo y sincronizamos cuando vuelva la señal.</span>
        </span>
      </div>
    </div>
  );
}
